import { GroupSearch } from './group-search';

export class InfluencerSearch extends GroupSearch {
  audienceFilters: Array<any> = [];
}



// WEBPACK FOOTER //
// ./src/models/influencer-search.ts